import React, { useRef } from 'react';
import Link from "next/link";
import { BiSearch, BiLogoWordpress, BiLogoApple, BiLogoAndroid, BiLogoReact, BiEnvelope } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';
const SubscribeStyleOne = () => {
    const container = useRef();
    const { t } = useTranslations();
    return (
        <div className="subscribe-content border-radius-0" ref={container}>
            <h2>{t("subscribe_title")}</h2>
            <Link href="/kontakt" className='default-btn-inside'>
                <BiEnvelope style={{ marginRight: '8px' }} />
                {t("subscribe_button")}
            </Link>
            <div className="shape14">
                <BiSearch style={{ width: '128px', height: '128px', color: '#91dc5a' }} />
            </div>
            <div className="shape15">
                <BiLogoReact style={{ width: '64px', height: '64px', color: '#91dc5a' }} />
            </div>
            <div className="shape16">
                <BiLogoWordpress style={{ width: '64px', height: '64px', color: '#91dc5a' }} />
            </div>
            <div className="shape17">
                <BiLogoAndroid style={{ width: '64px', height: '64px', color: '#91dc5a' }} />
            </div>
            <div className="shape18">
                <BiLogoApple style={{ width: '128px', height: '128px', color: '#91dc5a' }} />
            </div>

        </div>
    );
}

export default SubscribeStyleOne;
